import PythonApi from '@/services/PythonApi';

export default {
    async get(payload) {
        const url = "statuses", params = new URLSearchParams();
        if (payload) {
            if (payload.totals_only)
                params.append('totals_only', true);

            if (payload.status_type && payload.status_type.length > 0)
                payload.status_type.forEach((status_type) => params.append('status_types', status_type));

            if (payload.active_only)
                params.append('active_only', true);

            if (payload.with_cow)
                params.append('with_cow', true);

                if(payload.with_heat_index)
                    params.append('with_heat_index', true)

            if (payload.with_building)
                params.append('with_building', true);
        }
        return PythonApi().get(url, params, true);
    }
};



// WEBPACK FOOTER //
// ./src/api/statuses-api.js